import React, { useCallback, useEffect, useState } from 'react';
import WaAdminShell from '../../components/admin/whatsapp/WaAdminShell';
import { addWaBlock, fetchWaBlocklist, removeWaBlock } from '../../utils/adminWhatsapp';

export default function WhatsAppBlocklist() {
  const [rows, setRows] = useState([]);
  const [phone, setPhone] = useState('');
  const [reason, setReason] = useState('spam');

  const load = useCallback(async () => {
    try {
      const data = await fetchWaBlocklist();
      setRows(data.blocklist || []);
    } catch {
      setRows([]);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const add = async (e) => {
    e.preventDefault();
    await addWaBlock(phone, reason);
    setPhone('');
    load();
  };

  return (
    <WaAdminShell title="Blocklist" subtitle="Blocked numbers cannot use the bot">
      <form onSubmit={add} className="flex flex-wrap gap-2 mb-6 bg-white border rounded-xl p-4">
        <input className="border rounded-lg p-2 text-sm" placeholder="Phone" value={phone} onChange={(e) => setPhone(e.target.value)} required />
        <input className="border rounded-lg p-2 text-sm" placeholder="Reason" value={reason} onChange={(e) => setReason(e.target.value)} />
        <button type="submit" className="bg-[#1B375B] text-white px-4 py-2 rounded-lg text-sm">Block</button>
      </form>
      <ul className="bg-white border rounded-xl divide-y">
        {rows.map((r) => (
          <li key={r.id} className="p-3 flex justify-between items-center text-sm">
            <span>
              <span className="font-mono">{r.phone_masked}</span>
              <span className="text-gray-500 ml-2">{r.reason}</span>
            </span>
            <button type="button" className="text-xs text-red-600" onClick={() => removeWaBlock(r.id).then(load)}>
              Unblock
            </button>
          </li>
        ))}
        {rows.length === 0 && <li className="p-6 text-center text-gray-500">No blocked numbers</li>}
      </ul>
    </WaAdminShell>
  );
}
